<button
  (click)="clicked.emit()"
  class="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl"
>
  <img [src]="icon()" [alt]="label()" class="w-5 h-5 brightness-0 invert" />
  {{ label() }}
</button>
